export async function authenticateWithGoogle() {
    return new Promise((resolve, reject) => {
        const clientId = '168038852712-ba0t0heh46pnhvgjnd8udt10q4815ohr.apps.googleusercontent.com';
        //const redirectUri = window.location.origin;
        const redirectUri = `${window.location.origin}/authcallback`;
        const scope = encodeURIComponent('https://www.googleapis.com/auth/drive.file');
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=token&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
        const popup = window.open(authUrl, '_blank', 'width=500,height=600');
        if (!popup) {
            reject(new Error('No se pudo abrir la ventana de autenticación'));
            return;
        }
        const interval = setInterval(() => {
            try {
                const popupUrl = popup.location.href;
                if (popupUrl.startsWith(redirectUri)) {
                    const hash = popup.location.hash;
                    const params = new URLSearchParams(hash.substring(1));
                    const accessToken = params.get('access_token');
                    if (accessToken) {
                        clearInterval(interval);
                        popup.close();
                        window.googleDriveToken = accessToken; //guardar token
                        resolve({ success: true, token: accessToken });
                    }
                    else {
                        clearInterval(interval);
                        popup.close();
                        reject(new Error('No se recibió token'));
                    }
                }
            }
            catch (error) {
            }
        }, 500);
    });
}
